import React from 'react';
import Alex from '../../Assets/AlexDorval.JPG';

const About = () => {



  return (
    
      <section className='flex min-h-screen flex-wrap items-center'>
        <div className= 'w-full md:w-1/2'>
        <h2 className='my-8 p-2 text-4xl font-bold md:text-5xl lg:text-[7rem]'>
          Alex Dorval
        </h2>
        <p className='mb-8 p-2 text-xl'>
        Entry-level mechanical engineer with a strong mechatronics background and hands-on design experience. Proven ability to take projects from concept to completion – including CAD modeling, prototyping, and programming – and to collaborate in team settings. Seeking a role in mechanical design, robotics, or automation where I can apply my SolidWorks proficiency, fabrication skills, and control systems knowledge to solve real-world problems
        </p>
        </div>
        <div className='w-full md:w-1/2 lg:p-8'>
            <div className=' flex justify-center'>
              <img src={Alex} alt='Alex-Dorval' className='rounded-3xl'/>

            </div>

        </div>
        
      </section>
    
  )
}

export default About